<template>
  <div class="LangCurrencyForm">
    <h4 v-if="currencyVisible" class="LangCurrencyForm-title">{{ t('ui.components.languageSelector.title') }}</h4>
    <h4 v-else class="LangCurrencyForm-title">{{ t('ui.components.languageSelector.title') }}</h4>
    <Dropdown
      v-model="language"
      :label="t('ui.components.languageSelector.language')"
      :options="languageOptions"
    />
    <Dropdown
      v-if="currencyVisible"
      v-model="currency"
      :label="t('ui.components.languageSelector.currency')"
      :options="currencyOptions"
      :disabled="currencyDisabled"
    />
    <ActionButton
      variant="primary"
      class="LangCurrencyForm-confirmButton"
      :loading="loading"
      @click="$emit('confirm')"
    >
      {{ t('ui.components.languageSelector.confirm') }}
    </ActionButton>
  </div>
</template>

<script setup lang="ts">
import type { Locale } from 'vue-i18n';
import type { DropdownOption } from '@cvo/ui/components/molecules/Dropdown/Dropdown.model';

defineProps<{
  languageOptions: Array<DropdownOption<Locale>>;
  currencyOptions: Array<DropdownOption<string>>;
  currencyDisabled: boolean;
  currencyVisible: boolean;
  loading?: boolean;
}>();

defineEmits<{
  confirm: [];
}>();

const { t } = useI18n();

const language = defineModel<Locale | undefined>('language');
const currency = defineModel<string | undefined>('currency');

</script>

<style lang="scss">
@use 'assets/scss/theme' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-base {
  // Shared form styles
  .LangCurrencyForm {
    display: flex;
    flex-direction: column;
    gap: vars.$dimensions-d-4;

    &-title {
      color: vars.$organisms-panel-dropdown-title-color;
      @include text.text('md');
    }

    &-confirmButton {
      margin-top: vars.$dimensions-d-2;
    }
  }
}
</style>
